
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getCurrentDate, dateToSeconds, pickerAddOptions, dateToTimezone } from '@/utils/dateTime'
import { getProductInfo } from '@/api/product/productAccount'
import { setProductInfo } from '@/api/product/product'

@Component({
  name: 'IndiaH5Extra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    notify_after_collect: 0,
    last_collect_time: '',
  }

  private date: any = getCurrentDate()[0]
  private pickerOptions = pickerAddOptions

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private async noExtraUpdate() {
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        notify_after_collect: this.extraParam.notify_after_collect,
        last_collect_time: this.extraParam.last_collect_time,
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange (old) {
    if (old) {
      this.extraParam.last_collect_time = dateToSeconds(this.date)
    } else {
      this.extraParam.last_collect_time = ''
    }
  }

  // private pickerChangeTime (val) {
  //   console.log(new Date(val).getTime())
  // }

  private flagBtn: boolean = false
  private openPayTgGroup () {
    this.flagBtn = !this.flagBtn
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (res.extra_param.notify_after_collect) {
        this.extraParam.notify_after_collect = res.extra_param.notify_after_collect
      } else {
        this.extraParam.notify_after_collect = 0
      }

      if (res.extra_param.last_collect_time) {
        // this.extraParam.last_collect_time = res.extra_param.last_collect_time
        this.date = new Date(res.extra_param.last_collect_time * 1000 - 3600 * 1000 * 2.5)
        this.extraParam.last_collect_time = dateToSeconds(this.date)
      } else {
        this.extraParam.last_collect_time = ''
      }
    })
  }

  mounted() {
    this.getInfo()
  }
}
